import request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 获取订单列表
   */
  static getOrderList(params) {
    return request({
      url: 'tradecore/order/periods-order-status/list-by-page',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 取消订单
   */
  static cancelOrder(orderId) {
    return request({
      url: `tradecore/order/cancel/${orderId}`,
      host: config.HOST_MALL,
      method: 'post_json'
    });
  }

  /**
   * 确认收货
   */
  static takeOver(params) {
    return request({
      url: `tradecore/order/delivery`,
      host: config.HOST_MALL,
      method: 'post_json',
      params
    });
  }

  /**
   * 查询期数列表
   */
  static getPeriodList(params) {
    return request({
      url: `tradecore/period/getPeriodListBySys`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 调期申请
   */
  static appySwitch(params) {
    return request({
      url: `tradecore/order/adjust/periods`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/TradeManage/OrderSwitch/OrderSwitchServ.js